import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default {
  SET_ACCOUNT: function (state, payload) {
    state.account = payload
  },
  SET_MEMBER_ROLE_PERMISSION: function (state, payload) {
    state.permissionRole = payload
  }
}
